import _d from '@repperjs/debug';
import isUndefined from 'lodash/isUndefined.js';
import { all, call } from 'redux-saga/effects';

/* eslint-disable no-unused-vars */
const log = _d('repper:store:saga'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

const hasSaga = (route) => !isUndefined(route.saga);

const createMainSaga = (routes) =>
    function* () {
        log('running main saga');
        // @TODO: we should run route specific sagas only when the route is loaded for the first time
        yield all(routes.filter(hasSaga).map((route) => call(route.saga)));
    };

export default createMainSaga;
